import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {Box, Stack} from "@mui/material";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@mui/icons-material/Clear";
import _ from "lodash";
import {expertPaymentActions} from "_actions";
import useLocationQueryParams from "../../hooks/useLocationQueryParams";
import importedStyles from "../Proactive/Utilities/styles";
import BasicTextField from "../../common/BasicTextField";
import ExpertPaymentTable from "./ExpertPaymentTable";
import useExpertListFetch from "./Utilities/hooks/useExpertListFetch";

export default function ExpertPaymentList() {
    const dispatch = useDispatch();
    const offsetBase = 10;
    const { params, setParams } = useLocationQueryParams();
    const queryParams = new URLSearchParams(window.location.search);
    const search = queryParams.get("search") || '';
    const offset = parseInt(queryParams.get("offset")) || 0;

    const [page, setPage] = useState(() => offset / offsetBase);

    const [searchField, setSearchField] = useState({ expertSearch: search });



    const payload = {
        ...(search && { search }),
        offset: page * offsetBase,
    };

    const { rows, columns, totalCount, loading } = useExpertListFetch(payload);

    const handlePageChange = (event, nextPage) => {
        setPage(nextPage);

        const queryParam = {
            ...params,
            offset: nextPage * offsetBase,
            ...(search && { search }),
        };

        setParams(queryParam);
        dispatch(expertPaymentActions.listExperts(queryParam));
    };

    const handleSearchField = (event) => {
        const { name, value } = event.target;
        setSearchField(prev => ({ ...prev, [name]: value }));
    };

    const handleSearchOnKeyDown = (event) => {
        if (event.keyCode === 13) searchExperts();
    };

    const clearSearchField = () => {
        if (!searchField?.expertSearch?.trim()) return;

        setSearchField(prev => ({ ...prev, expertSearch: '' }));
        const { search, ...remainingParams } = params;

        const newUrl = Object.keys(remainingParams).length
            ? `${window.location.pathname}?${new URLSearchParams(remainingParams)}`
            : window.location.pathname;

        window.history.replaceState(null, '', newUrl);
        setParams(remainingParams);
        dispatch(expertPaymentActions.listExperts(remainingParams));
    };

    const searchExperts = () => {
        if (_.isEmpty(searchField?.expertSearch)) return;

        const searchParam = { search: searchField.expertSearch };
        const updatedParams = { ...params, ...searchParam };

        setParams(updatedParams);
        dispatch(expertPaymentActions.listExperts(updatedParams));
    };

    return (
        <Box sx={styles.root}>
            <Box sx={styles.container}>
                <Stack direction={{ xs: 'column', md: 'row' }} sx={styles.hero} spacing={2}>
                    <Box component={'h1'} sx={importedStyles.headingLarge}>
                        Expert Payments
                    </Box>
                    <Box sx={styles.filterContainer}>
                        <Box sx={{ width: '390px' }}>
                            <BasicTextField
                                name={'expertSearch'}
                                value={searchField?.expertSearch || ''}
                                startIcon={<SearchIcon sx={styles.icon} />}
                                endIcon={<ClearIcon sx={styles.clearIcon} />}
                                placeholder={'Name or Email - Press Enter to search'}
                                handleChange={handleSearchField}
                                handleIconAction={clearSearchField}
                                onKeyDown={handleSearchOnKeyDown}
                                sx={{ backgroundColor: '#fff', borderRadius: '10px', height: '40px' }}
                            />
                        </Box>
                    </Box>
                </Stack>

                <Box>
                    <ExpertPaymentTable
                        rows={rows}
                        columns={columns}
                        totalCount={totalCount}
                        page={page}
                        loading={loading}
                        handlePageChange={handlePageChange}
                        clickable={false}
                    />
                </Box>
            </Box>
        </Box>
    );
}

const styles = {
    root: {
        ...importedStyles.root,
        backgroundColor: '#EFEAE7',
        pt: 16,
        pb: 10,
        minHeight: '100vh',
    },
    container: {
        px: { xs: 2, sm: 6 },
        maxWidth: '1440px',
        position: 'relative',
    },
    hero: {
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', md: 'center' },
        mb: { xs: '24px', sm: '40px' },
    },
    filterContainer: {
        width: { xs: '100%', sm: 'auto' },
        height: '40px',
        display: 'flex',
        gap: 2,
    },
    filtersContainer: {
        width: '131px',
    },
    icon: {
        color: '#495D5E',
    },
    clearIcon: {
        fontSize: '18px',
        flexShrink: 0,
        color: '#495D5E',
        pointerEvents: 'none',
    },
};